import LogoWithHeader from './LogoWithHeader';
import { LogoWithHeaderProps, LogoWithHeaderValueProps } from './types';

export type { LogoWithHeaderProps, LogoWithHeaderValueProps };
export default LogoWithHeader;
